import { useLottiePlayer, useTranslation } from '@starsoft/common/hooks';
import styles from './styles.module.scss';

/**
 * KYC User Identity No KYC Required Component
 * Displays a message indicating that KYC verification is not required for the selected coin.
 * Shows an animation and translated text content.
 *
 * @component
 * @returns {JSX.Element} Component displaying no KYC required message with animation
 *
 * @example
 * // Basic usage
 * <KycUserIdentityNoKycToSelectedCoin />
 *
 * // The component internally uses:
 * const { t } = useTranslation('common');
 * const { lottieAnimationRef } = useLottiePlayer({
 *   path: '/success.json'
 * });
 *
 * // And renders translated text:
 * t('kyc_not_required_title')     // e.g. "No KYC Required"
 * t('kyc_not_required_description') // e.g. "You can proceed without KYC verification"
 */
export default function KycUserIdentityNoKycToSelectedCoin() {
  const { t } = useTranslation('common');

  const { lottieAnimationRef } = useLottiePlayer({
    path: '/success.json',
  });

  return (
    <div className={styles.container}>
      <div className={styles.container__lottie} ref={lottieAnimationRef} />

      <div className={styles.container__wrapper}>
        <div className={styles.container__wrapper__title}>
          {t('kyc_not_required_title')}
        </div>
        <div className={styles.container__wrapper__description}>
          {t('kyc_not_required_description')}
        </div>
      </div>
    </div>
  );
}
